<form [formGroup]="orderSummaryFormGroup">
  <div [ngClass]="class" *ngIf="plan$ | async as plan">
    <h4 class="mb-1">{{ orderSummaryData['orderOverview'] }}</h4>
    <p class="text-dark-grey mb-5">
      <ng-container *ngIf="isNewCustomer; else existingCustomer">
        Vetragsbeginn und Rechnung erfolgt nach Auslieferung und jeweils zum 1. des Folgemonats.
      </ng-container>
      <ng-template #existingCustomer>
        Wunschtermin {{ isNewCustomer ? 'Vertragsbeginn' : 'Vertragsumstellung' }}:
        <span class="text-primary-color text-bold">{{ plan.startDate | customDateFormat }}</span>
      </ng-template>
    </p>
    <div class="{{ class + '__plan text-medium' }}" [ngClass]="{ 'mb-3': isNewCustomer }">
      <div class="flex justify-content-between mb-2">
        <p class="big-text">Gewähltes Paket</p>
        <p class="text-medium">Preis/Monat</p>
      </div>
      <div class="flex justify-content-between mb-2">
        <p class="text-dark-grey text-medium">
          {{ plan.planType }}
        </p>
        <p class="flex-shrink-0 text-medium">{{ plan.price | euroCurrency }}</p>
      </div>
      <p class="mb-3 pb-1 text-dark-grey-2 {{ class }}__basic-module">
        Grundmodul
        <span class="text-primary-color">{{ plan.planType | basicModuleText }}</span>
      </p>

      <div [ngClass]="class + '__addons'">
        <div *ngFor="let module of plan.additionalModules">
          <div
            *ngIf="planCalculatorService.getModuleCalculatedPrice(module.price, module.name, plan.workStationCount, plan.planType)"
            class="flex justify-content-between"
          >
            <p class="text-dark-grey text-medium mb-2">
              {{ module.name }}
            </p>
            <p *ngIf="module" class="text-medium">
              {{
                planCalculatorService.getModuleCalculatedPrice(module.price, module.name, plan.workStationCount, plan.planType)
                  | euroCurrency
              }}
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="plan.clientsCount" class="flex justify-content-between mb-2">
        <p class="text-medium">
          <span class="text-primary-color text-bold">{{ plan.clientsCount }}</span>
          {{ plan.clientsCount | pluralize : 'client' }}
        </p>
        <p class="text-medium">{{ planCalculatorService.getClientsCost(plan.clientsCount) | euroCurrency }}</p>
      </div>

      <div *ngIf="plan.workStationCount" class="flex justify-content-between">
        <p class="text-medium">
          <span class="text-primary-color text-bold">{{ plan.workStationCount }}</span>
          {{ plan.workStationCount | pluralize : 'workStation' }}
        </p>
        <p class="text-medium">{{ planCalculatorService.getTotalWorkStationCostWithModule(plan) | euroCurrency }}</p>
      </div>
    </div>
    <div class="{{ class + '__subtotal' }}">
      <div class="flex justify-content-between">
        <p class="">{{ orderSummaryData['subtotalTitle'] }}</p>
        <p class="text-primary-color text-bold">
          {{ planCalculatorService.getSubtotal(plan) | euroCurrency }}
        </p>
      </div>
    </div>
    <div class="{{ class + '__rebate mb-2' }}" *ngIf="!isNewCustomer">
      <div class="flex justify-content-between">
        <p class="text-primary-color">
          {{ isNewCustomer ? plan.legacyProductDiscount?.discount : planCalculatorService.resolveDiscount(plan)
          }}{{ orderSummaryData['rebateTitle'] }}
        </p>
        <p class="text-dark-grey text-bold">-{{ planCalculatorService.getRebate(plan) | euroCurrency }}</p>
      </div>
    </div>
    <div *ngIf="plan.cloudVersion" class="flex justify-content-between mb-2">
      <p class="text-medium">
        <span class="text-primary-color text-bold">Cloud Version</span>
      </p>
      <p class="text-medium text-primary-color">
        +{{ planCalculatorService.getCloudVersionCost(plan.cloudVersion, plan.workStationCount) | euroCurrency }}
      </p>
    </div>

    <div *ngIf="plan.devicesCount" class="flex justify-content-between mb-2">
      <p class="text-medium">
        <span class="text-primary-color text-bold">{{ plan.devicesCount }}</span>
        {{ plan.devicesCount | pluralize : 'device' }}
      </p>
      <p class="text-medium text-primary-color">+{{ planCalculatorService.getTotalDeviceCost(plan.devicesCount) | euroCurrency }}</p>
    </div>

    <div *ngIf="plan.legacyProductDiscount?.discount && (plan.legacyProductDiscount?.discount || 0) > 0" class="{{ class + '__subtotal' }}">
      <div class="flex justify-content-between">
        <p class="text-medium text-primary-color">Sonderrabatt {{ plan.legacyProductDiscount?.discount }}%</p>
        <p class="text-medium text-primary-color">
          {{ planCalculatorService.getSubtotal(plan) * ((plan.legacyProductDiscount?.discount || 0) / 100) | euroCurrency }}
        </p>
      </div>
    </div>

    <div class="mb-6">
      <div class="flex justify-content-between mb-1">
        <h4>{{ orderSummaryData['totalTitle'] }}</h4>
        <h4>
          {{
            (isNewCustomer
              ? planCalculatorService.getNewPlanTotal(plan, plan.legacyProductDiscount?.discount || 0)
              : planCalculatorService.getTotal(plan, isNewCustomer)
            ) | euroCurrency
          }}
        </h4>
      </div>
      <p *ngIf="showOldDiscountNote" class="small-text text-dark-grey-2">Gilt für mindestens 12 Monate ab Umstellungsdatum.</p>
      <p class="small-text text-dark-grey-2">Alle genannten Preise verstehen sich exklusive Mehrwertsteuer.</p>
    </div>
    <div class="mb-4">
      <p>
        Mit der Online-Bestellung von smarthandwerk akzeptieren Sie die
        <a href="https://smarthandwerk.de/agb/" target="_blank" class="text-underlined text-bold">
          Allgemeinen Geschäftsbedingungen (AGBs)
        </a>
        , sind Sie mit der Verarbeitung Ihrer eingegangenen Daten, der Kontaktaufnahme sowie der
        <a href="https://bluesolution.de/datenschutzerklaerung/" target="_blank" class="text-underlined text-bold">Datenschutzerklärung</a>
        ein-verstanden und stimmen dem
        <a
          [routerLink]="
            isNewCustomer
              ? [
                  '/bestellung/pdf',
                  'sample-draft.pdf?sp=r&st=2025-02-19T09:29:35Z&se=2099-02-19T17:29:35Z&spr=https&sv=2022-11-02&sr=b&sig=TswvlnMqBprbnEoe0Nu%2F8I1vFab%2FJpPNH6EMYBjpe4Y%3D'
                ]
              : [
                  '/pdf',
                  userID,
                  'sample-draft.pdf?sp=r&st=2025-02-19T09:29:35Z&se=2099-02-19T17:29:35Z&spr=https&sv=2022-11-02&sr=b&sig=TswvlnMqBprbnEoe0Nu%2F8I1vFab%2FJpPNH6EMYBjpe4Y%3D'
                ]
          "
          target="_blank"
          class="text-underlined text-bold"
        >
          {{ orderSummaryData['agreementLinkText'] }}
        </a>
        zwischen blue:solution (Auftragnehmer) und Ihnen (Auftraggeber) zu.
      </p>
    </div>
    <p class="text-dark-grey-2 mb-4">{{ orderSummaryData['hint'] }}</p>

    <div class="{{ class + '__recaptch flex mb-6' }}">
      <re-captcha (resolved)="resolved($event)" [siteKey]="recaptchaSiteKey"></re-captcha>
      <span class="required"></span>
      <span
        class="small-text block text-highlight"
        *ngIf="orderSummaryFormGroup.get('recaptcha')?.invalid && orderSummaryFormGroup.get('recaptcha')?.touched"
      >
        {{ getErrorMessage('recaptcha') }}
      </span>
    </div>

    <div class="mb-5">
      <lib-button
        [title]="orderSummaryData[isNewCustomer ? 'newCustomerOrderButton' : 'orderButton']"
        bStyle="solid"
        icon="pi-arrow-right"
        type="submit"
        (onClick)="onHandleClick()"
      ></lib-button>
      <p *ngIf="!orderFormValid && handleBtnClicked" class="mt-2 small-text text-highlight">
        Bitte prüfen Sie Ihre Eingabe. Bevor Sie fortfahren können, müssen alle Pflichtfelder* ausgefüllt werden.
      </p>
    </div>

    <ng-container *ngIf="!isNewCustomer">
      <div class="mb-3">
        <lib-button
          [title]="customer.salesPartner.contactDetails?.companyName + ' kontaktieren'"
          bStyle="outline"
          type="button"
          (onClick)="onClickSupport()"
        ></lib-button>
      </div>

      <p class="text-dark-grey font-light">
        {{ orderSummaryData['orderHelpText'] }}
      </p>
    </ng-container>
  </div>
</form>
